import { Grid } from "@mui/material";
import { Common } from "../../../common/src";
import { ClusteringItems } from "./ClusteringItems";
import { Dispatch, SetStateAction } from "react";

interface Props {
  displayProjects: { [name: string]: [Common.Project] };
  selectProject: Common.Project[];
  setSelectProject: (project: Common.Project[]) => void;
  isLanguage: boolean;
  jobsiteList: Common.LandlogJobSite[];
  userList: Common.ProjectUserList[];
  setErrorSnackbar: Dispatch<SetStateAction<boolean>>;
  setErrorMsg: Dispatch<SetStateAction<string>>;
  setOpenWarning: Dispatch<SetStateAction<boolean>>;
  setMsgWarning: Dispatch<SetStateAction<string>>;
  isARAvailable: boolean;
}

// Sort
const displaySortCompare = (aStr: string, bStr: string): number => {
  if (aStr < bStr) return 1;
  if (aStr > bStr) return -1;
  else return 0;
};

const ProjectList = (props: Props) => {
  // 昇順key
  const ascKeys = Object.keys(props.displayProjects).sort((a, b) => {
    return displaySortCompare(a, b);
  });

  // 正規表現 日本語(/^[ぁ-んァ-ヶｱ-ﾝﾞﾟ一-龠]*$/)
  const regexNumber = /[0-9]/;
  const regexEnglish = /[a-zA-Z]/;
  const regexKanzi = /^[一-龠]*$/;
  const regexKatakana = /^[ァ-ヶｱ-ﾝﾞﾟ]*$/;
  const regexHiragana = /^[ぁ-ん]*$/;
  // ソート順「ひらがな、カタカナ、漢字、英語、数字」
  const sortOrder = [
    regexNumber,
    regexEnglish,
    regexKanzi,
    regexKatakana,
    regexHiragana,
  ];
  const getSortValue = (sortStr: string) => {
    return sortOrder.findIndex((pattern) => pattern.test(sortStr));
  };

  const clusteringItems = ascKeys.map((key) => {
    // sortOrderの順に合わせて並び替える。
    props.displayProjects[key].sort((a, b) => {
      if (a.uploadTime !== b.uploadTime) {
        return displaySortCompare(
          a.uploadTime.toString(),
          b.uploadTime.toString()
        );
      } else {
        const aLevel = getSortValue(a.name.charAt(0));
        const bLevel = getSortValue(b.name.charAt(0));
        if (aLevel === bLevel) {
          return a.name.localeCompare(b.name, undefined, {
            numeric: true,
            sensitivity: "base",
          });
        }
        return bLevel - aLevel;
      }
    });
    return (
      <ClusteringItems
        displayProjects={props.displayProjects}
        index={key}
        selectProject={props.selectProject}
        setSelectProject={props.setSelectProject}
        key={key}
        isLanguage={props.isLanguage}
        userList={props.userList}
        jobsiteList={props.jobsiteList}
        setErrorSnackbar={props.setErrorSnackbar}
        setErrorMsg={props.setErrorMsg}
        setOpenWarning={props.setOpenWarning}
        setMsgWarning={props.setMsgWarning}
        isARAvailable={props.isARAvailable}
      />
    );
  });
  //リストを整形して返却
  return (
    <Grid container sx={{ padding: "0px 16px" }}>
      {clusteringItems}
    </Grid>
  );
};

export default ProjectList;
